import React from 'react';
import { NavLink } from 'react-router-dom';

interface MenuItemProps {
  label: string;
  href: string;
  icon?: React.ReactNode;
  onNavigate?: () => void;
}

export const MenuItem: React.FC<MenuItemProps> = ({ label, href, icon, onNavigate }) => {
  return (
    <NavLink 
      to={href}
      className={({ isActive }) => `mobile-menu-item ${isActive ? 'active' : ''}`}
      onClick={onNavigate}
    >
      {icon && <span className="mobile-menu-icon">{icon}</span>}
      <span className="mobile-menu-label">{label}</span>
    </NavLink>
  );
};
